import React, { useState, useRef, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

const Header: React.FC = () => {
  const location = useLocation();

  // Hide the header on the login and register pages
  if (location.pathname === "/login" || location.pathname === "/register") {
    return null;
  }

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLUListElement>(null);

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    window.location.href = "/login";
  };

  // Toggle the menu
  const handleHamburgerClick = () => {
    setMenuOpen((prev) => !prev);
  };

  // Close menu when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="app-header">
      <nav>
        {/* <div className="nav-brand">Fruit Management</div> */}

        {/* Hamburger Icon */}
        <div
          className={`menu-icon ${menuOpen ? "open" : ""}`}
          onClick={handleHamburgerClick}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navigation Links */}
        <ul
          ref={menuRef}
          className={`nav-links ${menuOpen ? "open" : ""}`}
          // optional: close the menu automatically when user clicks on a link
          onClick={() => setMenuOpen(false)}
        >
          <li>
            <Link to="/raw-fruit">Raw Fruit</Link>
          </li>
          <li>
            <Link to="/machines">Machines</Link>
          </li>
          <li>
            <Link to="/farmers">Farmers</Link>
          </li>
          <li>
            <Link to="/qr-code">Generate QR Code</Link>
          </li>
          <li>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
